import React from 'react';
import classNames from 'classnames';
import CloseIcon from '../../assets/formIcons/close.svg';
import IconButton from '../IconButton';
import EmptyWidth from '../EmptyWidth';
import styles from './css/index.module.scss';

function ManagersPhonesInfoModal({ closeModal }) {
  return (
    <div className={classNames('modal_wrapper', styles.modal)}>
      <div className={styles.header}>
        <EmptyWidth width={48} />
        <p className="modal_title_no_margin">Информирование</p>
        <IconButton svgPath={CloseIcon} onClick={closeModal} />
      </div>
      <div className={styles.content}>
        <p className={styles.text}>
          Оповещение о пришедшей брони отправляется через sms (при подключенном сервисе)
          {' '}
          или через бот в ТГ на те номера (до 3-х), которые можно добавить в поле
          {' '}
          (в боте ТГ нужно авторизоваться заранее, предоставив номер телефона).
          {' '}
          ТГ бот —
          {' '}
          <a
            href="https://t.me/smsc_bot"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            @smsc_bot
          </a>
        </p>
      </div>
    </div>
  );
}

export default ManagersPhonesInfoModal;
